import { orgType } from "@/common/constants.js";
import { committee } from "@/common/constants.js";
import moment from "moment";

export default {
  transOrgType: num => orgType[+num],
  GetAge: identityCard => {
    var len = (identityCard + "").length;
    var strBirthday = "";
    if (len == 18) {
      //处理18位的身份证号码从号码中得到生日和性别代码
      strBirthday =
        identityCard.substr(6, 4) +
        "/" +
        identityCard.substr(10, 2) +
        "/" +
        identityCard.substr(12, 2);
    }
    if (len == 15) {
      var birthdayValue = "";
      birthdayValue = identityCard.charAt(6) + identityCard.charAt(7);
      if (parseInt(birthdayValue) < 10) {
        strBirthday =
          "20" +
          identityCard.substr(6, 2) +
          "/" +
          identityCard.substr(8, 2) +
          "/" +
          identityCard.substr(10, 2);
      } else {
        strBirthday =
          "19" +
          identityCard.substr(6, 2) +
          "/" +
          identityCard.substr(8, 2) +
          "/" +
          identityCard.substr(10, 2);
      }
    }
    //时间字符串里，必须是“/”
    var birthDate = new Date(strBirthday);
    var nowDateTime = new Date();
    var age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (
      nowDateTime.getMonth() < birthDate.getMonth() ||
      (nowDateTime.getMonth() == birthDate.getMonth() &&
        nowDateTime.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  },
  idCardDeel: id => id.slice(0, 9) + "********", 
  // id.replace(/$(.?<=\d{10})\d{8}(?=\d{0})/, "********"),   // 这种断言写法的正则,不兼容ios,IE

  transCommittee: areaCodeLevel => {
    let committeeName = "";
    Object.keys(committee).forEach(key => {
      if (committee[key] === areaCodeLevel) {
        committeeName = key;
      }
    });
    return committeeName;
  },
  transImgUrl: url => process.env.VUE_APP_API_IMGURL + url,
  getDate: (date, format = "YYYY-MM-DD") => moment(date).format(format),
  transPoliceType:(type)=>{

  }
};
